import { render, staticRenderFns } from "./CompletedProjectsCard.vue?vue&type=template&id=05a104e7"
import script from "./CompletedProjectsCard.vue?vue&type=script&lang=js"
export * from "./CompletedProjectsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports